module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-VIMEO.6d9adc55.png";